import { Component, ViewEncapsulation, Input, ChangeDetectionStrategy, OnInit, ViewChild, EventEmitter, Output } from '@angular/core';
import { NgbModal, ModalDismissReasons, NgbActiveModal, NgbModalRef, NgbDateStruct, NgbDateParserFormatter } from '@ng-bootstrap/ng-bootstrap';

import { NgForm } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiResponseModel } from '../../../../models/api_response_model';
import { ActorService } from '../../../../services/actor.service';
import * as alertFunctions from '../../../../../shared/data/sweet-alerts';
import { DoctorsListController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { DoctorsListRequest } from '../../../../../../../src/app/ncs/models/actor/actor';
import { AppData } from '../../../../../../../src/app/ncs/models/appdata';
import { SpinnerService } from '../../../../../../../src/app/ncs/services/spinner.service';
import { DoctorListPipe } from '../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { PrescribingDoctor, ReferringDoctor, BillDetails, BillItemDeleted } from '../../_MasterClasses/BillingClasses';




@Component({
  selector: 'ngbaddbill',
  templateUrl: './addbill.modal.html',
  styleUrls: ['./addbill.modal.scss']
})

export class NgbAddBill implements OnInit {

  @Input() FormattedCode: string;
    @Output() passEntry: EventEmitter<any> = new EventEmitter();
  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;
  public ShowService: boolean = true;
  public Patientsearch: boolean = true;
  public Providerdetails: boolean = false;
    public ReferalDocName: string;
    public RefDoccode: number;
    public RefDesg: string;


  constructor(public activeModal: NgbActiveModal, private router: Router, private actorservice: ActorService,
    private loaderService: SpinnerService, private filter: DoctorListPipe, private filter1: DoctorListPipe,) { }

  ngOnInit() {

    this.LoadDoctorsList();
    this.LoadPatients();

  }

  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;

    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;
    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadSign();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentDoctorsListController: DoctorsListController[];
  CurrentDoctorsListRequest: DoctorsListRequest;

  LoadDoctorsList() {
    this.CurrentDoctorsListController = new Array<DoctorsListController>();

    this.CurrentDoctorsListRequest = new DoctorsListRequest();
    this.pdata = this.CurrentDoctorsListController;
    this.pdata1 = this.CurrentDoctorsListController;
      this.CurrentDoctorsListRequest.ConditionalOperator = 20;
      this.CurrentDoctorsListRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentDoctorsListRequest.ProvidersSpecality = "";
    this.CurrentDoctorsListRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetDoctorsListController();
  }
  GetDoctorsListController() {
    this.StartRefreshing();

    this.actorservice.GetDoctorsListController(this.CurrentDoctorsListRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          //alert();
          this.CurrentDoctorsListController = this.ApiResData.Result;
          this.pdata = this.CurrentDoctorsListController;
          this.pdata1 = this.CurrentDoctorsListController;
          //alert(this.CurrentServiceCategoriesController.length);

          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );

  }

  pdata: any[];
  listFilter: string;
  ngOnChanges(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata = this.CurrentDoctorsListController;

    this.criteriaChange(this.listFilter);
  }
  criteriaChange(value: any) {
    if (this.filter != null) {
      if (value != '[object Event]') {
        this.listFilter = value;
        //alert(this.listFilter);
        this.pdata = this.filter.transform(this.CurrentDoctorsListController, this.listFilter);
      }
    }
  }

  pdata1: any[];
  listFilter1: string;
  ngOnChanges1(changes: any) {
    if (JSON.stringify(changes).indexOf("data") != -1)
      this.pdata1 = this.CurrentDoctorsListController;

    this.criteriaChange1(this.listFilter1);
  }
  criteriaChange1(value: any) {
    if (this.filter1 != null) {
      if (value != '[object Event]') {
        this.listFilter1 = value;
        //alert(this.listFilter);
        this.pdata1 = this.filter1.transform(this.CurrentDoctorsListController, this.listFilter1);
      }
    }
  }



  provider() {
    this.Patientsearch = false;
    this.Providerdetails = true;
  }

  ModalClose() {
    this.activeModal.close();
  }
  Receipt() {
    this.router.navigate(['healins/receipt']);
    this.activeModal.close();

  }
    CurrentPrescribingDoctor: Array<PrescribingDoctor>;
    AddRowPrescriber(l: DoctorsListController) {
        
        if (this.CurrentPrescribingDoctor == null) {
            this.CurrentPrescribingDoctor = new Array<PrescribingDoctor>();
        }
        if (this.CurrentPrescribingDoctor != null) {
            
            var row = new PrescribingDoctor();
            row.DoctorName = l.DisplayName;
            row.DoctorCode = l.ProviderCode;
            row.Designation = l.Specialty;

            this.CurrentPrescribingDoctor.push(row);

        }
        if (this.CurrentPrescribingDoctor.length = 1) {
            this.CurrentPrescribingDoctor = null;
            this.CurrentPrescribingDoctor = new Array<PrescribingDoctor>();

            var row = new PrescribingDoctor();
            row.DoctorName = l.DisplayName;
            row.DoctorCode = l.ProviderCode;
            row.Designation = l.Specialty;

            this.CurrentPrescribingDoctor.push(row);

        }



       



    }
    CurrentReferringDoctor: Array<ReferringDoctor>;
    AddRowReferral(l: DoctorsListController) {
        if (this.CurrentReferringDoctor == null) {
            this.CurrentReferringDoctor = new Array<ReferringDoctor>();
        }
        if (this.CurrentReferringDoctor != null) {
            var row = new ReferringDoctor();
            row.DoctorName = l.DisplayName;
            row.DoctorCode = l.ProviderCode;
            row.Designation = l.Specialty;

            this.CurrentReferringDoctor.push(row);

        }
        if (this.CurrentReferringDoctor.length = 1) {
            this.CurrentReferringDoctor = null;
            this.CurrentReferringDoctor = new Array<ReferringDoctor>();
            var row = new ReferringDoctor();
            row.DoctorName = l.DisplayName;
            row.DoctorCode = l.ProviderCode;
            row.Designation = l.Specialty;

            this.CurrentReferringDoctor.push(row);

        }
        this.ReferalDocName = l.DisplayName;
        this.RefDoccode = l.ProviderCode;
        this.RefDesg = l.Specialty;
    }
    Data() {
        this.passEntry.emit({ make: this.CurrentPrescribingDoctor, value: this.CurrentReferringDoctor, RefDoc: this.ReferalDocName, RefDocCode: this.RefDoccode, RefDocDes: this.RefDesg });
        this.activeModal.close();
    }
  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }



}
//export class PrescribingDoctor {
//    public DoctorName: string;
//    public DoctorCode: number;
//    public Designation: string;
//}
//export class ReferringDoctor {
//    public DoctorName: string;
//    public DoctorCode: number;
//    public Designation: string;
//}
